import { clsx } from 'clsx';

export type ImageSkeletonProps = {
  isRounded?: boolean;
  className?: string;
};

export const ImageSkeleton = ({ isRounded, className }: ImageSkeletonProps) => {
  return (
    <div
      className={clsx('bg-black-200 animate-pulse', className, {
        'rounded-full': isRounded,
      })}
    />
  );
};
